'use client';

import type React from 'react';
import { useState } from 'react';
import { Provider } from 'react-redux';
import { type AppStore, makeStore } from '@/lib/store';

export default function StoreProvider({ children }: { children: React.ReactNode }) {
	const [store] = useState<AppStore>(() => makeStore());

	return <Provider store={store}>{children}</Provider>;
}
